var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{class:[{reverse: _vm.reverse, fade: _vm.fade, 'blink-out':_vm.blinkOut}, _vm.direction],style:({ '--total': _vm.total, '--time': _vm.duration }),attrs:{"appear":_vm.appear,"tag":"div","name":"slide-in-transition"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }